export class Price {
  taxAmount?: number | null;
  taxFree?: number | null;
  taxIncluded?: number | null;
  taxRate?: number | null;

  public static of(data: any): Price {
    const p: Price = new Price();
    p.taxFree = data?.taxFree;
    p.taxIncluded = data?.taxIncluded;
    p.taxRate = data?.taxRate;
    p.taxAmount = data?.taxAmount;
    return p;
  }
}